import { useState } from "react";

export const useFormClient = () => {

    const [isAddClientVisible, setIsAddClientFormVisible] = useState(false);
    const [isEditClientVisible, setIsEditClientVisible] = useState(false);
    const [isViewClientVisible, setIsViewClientVisible] = useState(false);
    const [isOpenCardsCredit, setOpenCardsCredit] = useState(false);


    const handlerFormAddClient = (action: "open" | "close") => {
        isOpenCardsCredit && handlerCardsCredit("close")
        isViewClientVisible && handlerFormViewClient("close")
        isEditClientVisible && handlerFormEditClient("close")

        action === "open" && setIsAddClientFormVisible(true);
        action === "close" && setIsAddClientFormVisible(false);
        
    }

    const handlerFormEditClient = (action: "open" | "close") => {
        isViewClientVisible && handlerFormViewClient("close")

        action === "open" && setIsEditClientVisible(true);
        action === "close" && setIsEditClientVisible(false);
    }

    const handlerFormViewClient = (action: "open" | "close") => {
        isEditClientVisible && handlerFormEditClient("close")

        action === "open" && setIsViewClientVisible(true);
        action === "close" && setIsViewClientVisible(false);
    }

    const handlerCardsCredit = (action: "open" | "close") => {
        isViewClientVisible && handlerFormViewClient("close")
        isEditClientVisible && handlerFormEditClient("close")
        isAddClientVisible && handlerFormAddClient("close")

        action === "open" && setOpenCardsCredit(true);
        action === "close" && setOpenCardsCredit(false);
    }

    return {
        handlerFormAddClient,
        handlerCardsCredit,
        handlerFormEditClient,
        handlerFormViewClient,

        isAddClientVisible,
        isEditClientVisible,
        isViewClientVisible,
        isOpenCardsCredit
    }
}